module.exports = __webpack_public_path__ + "static/media/BA.34083a4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BA.svg
// module id = 198
// module chunks = 0